import { RootState } from '@/models/root-state.model';
import { BffUserPlayStatsResponse } from '@lucky7ventures/bff-types';

export const selectUserPlayStats = (state: RootState): BffUserPlayStatsResponse | null =>
  state.userPlayStatsAndLimits.stats;
